import React from 'react';
import { product } from '../data/ebook';
import { Section } from './Section';
export function Author() {
  return <Section id="autora" className="bg-cream" data-id="element-11" data-mp="oiut53c9ijym">
      <div className="grid gap-12 lg:grid-cols-[0.75fr_1.25fr] lg:gap-16" data-id="element-12" data-mp="ojmgxrzmbdec">
        <div data-id="element-13" data-mp="9uq9nx5dy4es">
          <img src={product.authorImage} alt="La autora de Vientre Plano Express en su cocina" className="w-full rounded-lg object-cover" width={900} height={1125} data-id="element-14" data-mp="9qsq5aewbaud" />
        </div>

        <div className="flex flex-col justify-center" data-id="element-15" data-mp="17gxaqx2hdeme">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-dark" data-id="element-16" data-mp="17eb5x56z5d7v">
            Una nota personal de la autora
          </p>
          <blockquote className="mt-6 font-display text-3xl font-light leading-snug text-ink sm:text-4xl" data-id="element-17" data-mp="xhgbaxdtnwyv">
            «Yo pasé años pensando que estaba gorda, cuando en realidad estaba intoxicada e
            inflamada.»
          </blockquote>
          <div className="mt-7 space-y-5 text-[15px] leading-relaxed text-muted" data-id="element-18" data-mp="3i6cd5roz3x0z">
            <p data-id="element-19" data-mp="1tytyszhugwbv">
              Sé exactamente cómo te sientes. Estás frente al espejo, te subes el pantalón y, aunque
              no has comido nada del otro mundo, sientes que el abdomen tiene vida propia.
            </p>
            <p data-id="element-20" data-mp="1y05gmiuh8d9i">
              Probé jugos verdes que sabían a pasto, fajas que no me dejaban respirar y rutinas que
              solo me dejaban cansada y con el mismo vientre abultado. Este libro nació de esa
              frustración: es el protocolo que yo misma uso cuando tengo un evento, una sesión de
              fotos o simplemente cuando quiero sentirme liviana otra vez.
            </p>
            <p className="font-medium text-ink" data-id="element-21" data-mp="2ho4sxy4ovsh1">
              Estás aquí porque buscas una solución que funcione rápido. Bienvenida, vamos a
              lograrlo juntas.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}